// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://qoxuxpnqudnruddccmiy.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFveHV4cG5xdWRucnVkZGNjbWl5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTQ4OTQwNjAsImV4cCI6MjA3MDQ3MDA2MH0.8rkzlIku8VpXlyyTJsoS0HFMouEnSFNVdN_FLET1q9w";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});